module.exports = __webpack_public_path__ + "static/Building Work-b02e176e5d38741a2de796790c245959.jpg";